// extracted by mini-css-extract-plugin
var _1 = "paginationStyles-module__desktop-holder___mEFE1";
var _2 = "paginationStyles-module__desktop-holder___mEFE1";
var _3 = "paginationStyles-module__mobile-holder___GeI0y";
var _4 = "paginationStyles-module__mobile-select___tAr5g";
var _5 = "paginationStyles-module__mobile-holder___GeI0y";
var _6 = "paginationStyles-module__mobile-select___tAr5g";
var _7 = "paginationStyles-module__pagination___nGwxG";
var _8 = "paginationStyles-module__pagination__button___KIh1i";
var _9 = "paginationStyles-module__pagination__dots___MdZQh";
var _a = "paginationStyles-module__pagination__leftButton___jQgLQ";
var _b = "paginationStyles-module__pagination__rightButton___imDe8";
var _c = "paginationStyles-module__pagination__button___KIh1i";
var _d = "paginationStyles-module__pagination__dots___MdZQh";
var _e = "paginationStyles-module__pagination__leftButton___jQgLQ";
var _f = "paginationStyles-module__pagination__rightButton___imDe8";
export { _1 as "desktop-holder", _2 as "desktopHolder", _3 as "mobile-holder", _4 as "mobile-select", _5 as "mobileHolder", _6 as "mobileSelect", _7 as "pagination", _8 as "paginationButton", _9 as "paginationDots", _a as "paginationLeftButton", _b as "paginationRightButton", _c as "pagination__button", _d as "pagination__dots", _e as "pagination__leftButton", _f as "pagination__rightButton" }
